export const LogoFull = ({ className = "" }) => (
  <img src="/brand/logo-core.png" alt="core. – the heart of your business" className={className} data-testid="logo-full" />
);

export const LogoSidebar = () => (
  <img src="/brand/logo-core.png" alt="core. – the heart of your business" className="w-[190px]" data-testid="sidebar-logo" />
);
